import DataGrid, {
    Column,
    FilterRow,
    Paging,
    Scrolling
} from 'devextreme-react/data-grid';
import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';
import useFormatMessage from '../../../../utils/useFormatMessage';
import UpdateModal from './UpdateModal';

export default function UserTable({ dataSource, updateTrigger, setUpdateTrigger, dataGridRef }) {
    const [modalUpdate, setModalUpdate] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState()
    const { t } = useFormatMessage();

    function settingsCell(data) {
        return (
            <Row className="d-flex justify-content-around">
                <Col lg="3" className="d-flex justify-content-center">
                    <i className='fa fa-edit mt-2' onClick={() => { setSelectedUserId(data.data.employee_id); setModalUpdate(true) }} style={{ fontSize: "18px", cursor: "pointer", color: "blue" }}></i>
                </Col>
                {/* <Col lg="3" className="d-flex justify-content-center">
                <p style={{ cursor: "pointer", color: "blue" }} onClick={() => { setSelectedId(data.data.KopusFormId); setModalDelete(true); }} ><i className='fa fa-trash mt-2' style={{fontSize:"18px"}}></i></p>
            </Col> */}
            </Row>
        )
    }

    function permissionsCell(data) {
        if (data.data.permissions !== null) {
            return (
                data.data.permissions.map((group, index) => (
                    <Col xl="12" key={index}>{group.description} </Col>
                ))
            )
        } else {
            return (
                <>-</>
            )
        }
    }

    function rolesCell(data) {
        if (data.data.special_roles !== null) {
            return (
                data.data.special_roles.map((group, index) => (
                    <Col xl="12" key={index}>{group.description} </Col>
                ))
            )
        } else {
            return (
                <>-</>
            )
        }
    }

    function calculatePermissionCellValue(data) {

        if (data.permissions !== null) {
            let cellValue = "";

            data.permissions.forEach(group => {
                cellValue += group.description + " ";
            });
            return cellValue.trim(); // Trim to remove trailing space
        } else {
            return "";
        }
    }


    // function calculateRoleCellValue(data) {
    //     if (data.SpecialRoles !== null) {
    //         let cellValue = ""
    //         data.SpecialRoles.map(group => {
    //             cellValue += group.Description + " "
    //         })
    //         return cellValue
    //     } else {
    //         return ""
    //     }
    // }

    function calculateRoleCellValue(data) {
        if (data.special_roles !== null) {
            let cellValue = "";

            data.special_roles.forEach(group => {
                cellValue += group.description + " ";
            });

            return cellValue.trim(); // Trimming the trailing space
        } else {
            return "";
        }
    }


    return (
        <>
            <DataGrid
                dataSource={dataSource}
                showBorders={true}
                allowColumnResizing={true}
                // onExporting={onExporting}
                ref={dataGridRef}
                height={"71vh"}
                rowAlternationEnabled={true}
                showColumnLines={true}
                showRowLines={true}
            >
                {/* <Export enabled={true} /> */}
                <FilterRow visible={true} />
                <Column dataField="full_name" selectedFilterOperation={"contains"} caption={t("Kullanıcı Adı")} alignment="center" />
                <Column dataField="permissions" allowFiltering={true} cellRender={permissionsCell} calculateCellValue={calculatePermissionCellValue} selectedFilterOperation={"contains"} caption={t("Yetki Grupları")} alignment="center" />
                <Column dataField="special_roles" cellRender={rolesCell} selectedFilterOperation={"contains"} calculateCellValue={calculateRoleCellValue} caption={t("Özel Roller")} alignment="center" />
                <Column dataField="employee_id" cellRender={settingsCell} alignment="center" allowSorting={false} caption={t("Seçim")} />

                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                <Paging enabled={false} />
            </DataGrid>
            <UpdateModal modalUpdate={modalUpdate} setModalUpdate={setModalUpdate} dataId={selectedUserId} updateTrigger={updateTrigger} setUpdateTrigger={setUpdateTrigger} />

        </>
    )
}